import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {ReactComponent as ArrowLeft} from '../../../../../@casino/img/left-arrow.svg';
import {ReactComponent as ArrowRight} from '../../../../../@casino/img/right-arrow.svg';
import {useStyles} from './helpers';

const TableCasino = ({allPage, perPage, columns, rows, changePage, changeRowsPerPage, width, pagination, handleUpdateBalance, handleSelectedId, handleAdd}) => {
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(perPage);

    return (
        <div style={{maxWidth: width}} className={classes.w100}>
            <TableContainer className={classes.container} >
            <Table stickyHeader aria-label="sticky table" >
                <TableHead >
                <TableRow className={classes.h25}>
                    {columns.map((column, key) => (
                    <TableCell
                        key={column.id}
                        align={column.align}
                        style={{minWidth: column.minWidth, paddingLeft: key === 0 ? 10 : 0}}
                        className={classes.cell}
                    >
                        {column.label}
                    </TableCell>
                    ))}
                </TableRow>
                </TableHead>
                <TableBody className={classes.w100}>
                {rows.map((row, key) => {
                    return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code} style={{background: key % 2 === 0 ? '#141b33' : '#1b2039', height: 50}}>
                        {columns.map((column, key) => {
                        const value = row[column.id];

                        return (
                            <TableCell key={column.id} align={column.align} style={{paddingLeft: key === 0 ? 10 : 0}} className={classes.cellBody}>
                                {column.format && typeof value === 'number' ? column.format(value) : value}
                            </TableCell>
                        );
                        })}
                        <div style={{display: 'flex', columnGap: 12}}>
                            <div 
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: 50,
                                }}
                                onClick={() => {
                                    handleUpdateBalance(true);
                                    handleSelectedId(row.id);
                                    handleAdd(true);
                                }}
                            >
                                <span style={{
                                    background: 'gold',
                                    padding: '5px 10px',
                                    borderRadius: 4,
                                    userSelect: 'none',
                                    cursor: 'pointer'
                                }}>Пополнить</span>
                            </div>

                            <div 
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: 50,
                                }}
                                onClick={() => {
                                    handleUpdateBalance(true);
                                    handleSelectedId(row.id);
                                    handleAdd(false)
                                }}
                            >
                                <span style={{
                                    background: 'rgb(255, 49, 86)',
                                    padding: '5px 10px',
                                    borderRadius: 4,
                                    userSelect: 'none',
                                    cursor: 'pointer'
                                }}>Убрать</span>
                            </div>
                        </div>
                    </TableRow>
                    );
                })}
                </TableBody>
                
                
            </Table>
            {
                    rows.length === 0 &&
                  
                    <div className={classes.wrapnodata}>
                        <span className={classes.nodata}>Данных нет</span>
                    </div>
                
                }
            </TableContainer>
            {
                pagination &&
                <div className={classes.wrapPagination}>
                    <select 
                        className={classes.select}
                        value={rowsPerPage}
                        onChange={(v) => {
                            setRowsPerPage(v.target.value);
                            changeRowsPerPage({
                                page: page,
                                rowsPerPage: v.target.value
                            });
                        }}
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                    </select>
                    <input type="number" onChange={(v) => setPage(v.target.value)} value={page + 1} className={classes.inputnumber}/>
                    <span className={classes.countPage}>/ {allPage}</span>
                    <div className={classes.ml12}>
                        <span className={classes.arrowleft} onClick={() => {
                            if (page !== 0) {
                                changePage({page: page - 1, rowsPerPage: +rowsPerPage})
                                setPage(page - 1)
                            }
                            
                        }}>
                            <ArrowLeft className={classes.arrowRight}/>
                        </span>
                        <span className={classes.arrowright} onClick={() => {
                            if (page !== +allPage - 1) {
                                changePage({page: page + 1, rowsPerPage: +rowsPerPage})
                                setPage(page + 1)
                            }
                        }}>
                            <ArrowRight className={classes.arrowRight}/>
                        </span>
                    </div>
                </div>
            }
        </div>
    )
}

export default TableCasino;